
import CaseStudy, { CASE_STUDY_TYPES } from '../../../components/case-study/CaseStudy';
import Header from '../../../components/Header';
import Layout from '../../../components/Layout';
import ThumbnailImage from '../../../images/thumbnails/hcl_thumb.png';

export function Index() {
  return (
    <Layout 
    title="How HCL Tech enabled seamless photo sharing—without collecting PII"
    description="Hosting high-stakes events but can’t risk data sharing? Here is how HCL Tech kept it private with Premagic."
    metaImage={ThumbnailImage}
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.HCL} />
    </Layout>
  );
}

export default Index;